import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';


import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';
import DropZone from 'components/Shared/DropZone';


import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';

import stringHelper from 'utils/stringHelper';

const styles = {
    formControl: {
        margin: 0,
        marginTop: 10,
        width: '100%'
    },

    heightLabel: {
        height: '30px'
    },

    input: {
        marginTop: 10
    }
};

class DeclarerRetourPlateformeDialogContent extends React.Component {

    constructor(props) {
        super(props);

        let dateNow = new Date();

        let day = dateNow.getDate();
        if (day < 10) day = `0${day}`;

        let month = dateNow.getMonth() + 1;
        if (month < 10) month = `0${month}`;

        let year = dateNow.getFullYear();

        this.state = {
            codeDepot: props.codeDepot,
            dateRenvoi: `${year}-${month}-${day}`,
            numeroBT: '',
            fichiersIds: [],
            commentaire: ""
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action, plateformeVaulx } = this.props;

        if (!newState.codeDepot) {
            return null;
        }

        if (!newState.dateRenvoi) {
            return null;
        }
        
        if (stringHelper.isNullOrWhitespace(newState.numeroBT)) {
            return null;
        }


        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: "Dépôt",
                position: 0,
                valeurString: newState.codeDepot
            },
            {
                code: ReclamationActionDetailCodes.DateRenvoi,
                type: ReclamationActionDetailType.Date,
                libelle: 'Date de renvoi',
                position: 1,
                valeurDate: newState.dateRenvoi
            },
            {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de BT',
                position: 2,
                valeurString: newState.numeroBT
            },
            {
                code: ReclamationActionDetailCodes.Plateforme,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: 'Plateforme',
                position: 3,
                valeurString: plateformeVaulx ? '70' : '01'
            }
            ]
        };

        if (newState.commentaire) {
            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {


        let newState = {
                ...this.state,
                [event.target.name]: event.target.value
            };
 

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    render() {
        const { classes, plateformeVaulx } = this.props;
        const { numeroBT, codeDepot, commentaire } = this.state;

        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Réaffecter le dossier après-vente au groupe de traitement des retours `}{plateformeVaulx ? '(Vaulx)' : '(Monné)' }</Typography>      

                <FormControl margin="normal" className={classes.formControl}>
                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { this.handleChange({ target: { name: 'codeDepot', value: codeDepot } }); }}
                        label={"Dépôt"}
                        magasinsSeulement={false}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={true}
                        disabled={false}
                    />
                </FormControl>

                <FormControl className={classes.formControl}>
                    <TextField
                        id="dateRenvoi"
                        label="Date de renvoi"
                        type="date"
                        value={this.state.dateRenvoi}
                        onChange={this.handleChange}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            name: 'dateRenvoi',
                            id: 'dateRenvoi'
                        }}
                        required
                    />
                </FormControl>

                <TextField className={classes.input} id="numeroBT" name="numeroBT" label="Numéro de BT" value={numeroBT} onChange={this.handleChange} fullWidth />

                <TextField className={classes.formControl}
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={e => this.handleChange(e)}
                />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
            </DialogContent>
        );
    }
}

DeclarerRetourPlateformeDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    codeDepot: PropTypes.string
};

export default withStyles(styles)(DeclarerRetourPlateformeDialogContent);